var $ = require("jquery");

$(document).on('change', "input#SubscriberType", (event) => {

    const customerSection = $('#Customer');
    const supplierSection = $('#Supplier');

    // skrýt vše
    customerSection.slideUp();
    supplierSection.slideUp();

    // vyčistit všechny dropdowny
    customerSection.find('select').prop('disabled', true);
    supplierSection.find('select').prop('disabled', true);

    // zobrazit příslušný dropdown
    const value = event.target.value;
    const selectedSection = $('#' + value);
    selectedSection.find('select').prop('disabled', false);
    selectedSection.slideDown();
});

$('input#SubscriberType[checked=checked]').each(function () {
    $(this).closest('label').addClass('active');
});


// WEBPACK FOOTER //
// ./App/containers/user-management.js